// extracted by mini-css-extract-plugin
export default {"generalMainContent":"general_generalMainContent__pzu5x","container":"general_container__Rf8Xl"};